import React from 'react'

function ProgInsuranceCCTable({data}) {
    return (
        <>
            <div>
                <div className={`min-w-full ${data ? 'w-max' : 'flex-1'} flex justify-center py-2`}>
                    <table className="min-w-full bg-white border border-gray-200 text-sm">
                        <thead className="bg-[#B9DFE2] text-white">
                            <tr>
                                <th className="px-4 border">Diagnosed Date</th>
                                <th className="px-4 border">Chronic Code</th>
                                <th className="px-4 border">Description</th>
                            </tr>
                            {/* <tr className="bg-[#DEF3F2]">
                                <td className="py-0.5" colSpan={12}></td>
                            </tr> */}
                        </thead>
                        <tbody className="text-center">
                            {data?.map((item, idx) => (
                                <React.Fragment key={idx}>
                                    <tr>
                                        <td className="px-4 border">{item.givenDate ? new Date(item.givenDate).toLocaleDateString() : ''}</td>
                                        <td className="px-4 border">{item.chronicCode}</td>
                                        <td className="px-4 border">{item.chronicDescription}</td>
                                    </tr>
                                    {/* <tr className="bg-[#DEF3F2]">
                                        <td className="py-0.5" colSpan={12}></td>
                                    </tr> */}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default ProgInsuranceCCTable;